// extracted by mini-css-extract-plugin
module.exports = {"Intro":"Intro_3kcW","Intro__inner":"Intro__inner_2DyZ","brand":"brand_26yd"};